import { differenceInMinutes } from 'date-fns';
import { Maybe } from '@iss/libs/graphql';

export const getTimestamp = (): number => +new Date();
export const timeoutPassed = (timestamp: Maybe<number>): boolean => timestamp ? differenceInMinutes(getTimestamp(), timestamp) > 0 : false;
